import styled from 'styled-components';

export const Container = styled.div`
  margin-left: 100px;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const GreetingContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 7px;
`;

export const RoleContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 7px;
`;

export const ItemsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 30px;
`;

